import React from 'react'

export const ChatVideoSelectedIcon = ({
  size = 30,
  className,
  opacity = 1,
}: {
  color?: string
  size?: number
  className?: string
  opacity?: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      className={className}
      fill="none"
      opacity={opacity}
    >
      <g>
        <path
          d="M17.542 6.5C17.8771 6.50002 18.2092 6.53626 18.5332 6.60547L18.4922 6.6875L17.9209 7.9209L16.6875 8.49219C15.4019 9.08649 15.4019 10.9135 16.6875 11.5078L17.9209 12.0781L18.4922 13.3125L18.5508 13.4287C19.1985 14.597 20.932 14.5582 21.5078 13.3125L22.0781 12.0781L23.3125 11.5078L23.415 11.4551C23.4704 11.7459 23.5 12.0428 23.5 12.3428V18.75C23.5 21.3734 21.3734 23.5 18.75 23.5H11.25C8.62665 23.5 6.5 21.3734 6.5 18.75V11.25C6.5 8.62665 8.62665 6.5 11.25 6.5H17.542ZM13.4248 11.4922C12.7915 11.1269 12 11.5842 12 12.3154V17.6846C12 18.4158 12.7915 18.8731 13.4248 18.5078L18.0752 15.8223L18.1865 15.748C18.6713 15.3719 18.6713 14.6281 18.1865 14.252L18.0752 14.1777L13.4248 11.4922ZM16.5 15L13.5 16.7314V13.2686L16.5 15ZM19.9004 7.25879C19.977 7.19791 20.1 7.21637 20.1465 7.31641L20.9229 8.99805C20.9389 9.03282 20.9672 9.06108 21.002 9.07715L22.5107 9.77344L22.6836 9.85352C22.808 9.91134 22.808 10.0887 22.6836 10.1465L21.002 10.9229C20.9672 10.9389 20.9389 10.9672 20.9229 11.002L20.1465 12.6836C20.0887 12.808 19.9113 12.808 19.8535 12.6836L19.0771 11.002C19.0611 10.9672 19.0328 10.9389 18.998 10.9229L17.3164 10.1465C17.2073 10.0957 17.194 9.95309 17.2764 9.87988L17.3164 9.85352L17.4883 9.77344L18.998 9.07715L19.0439 9.04395C19.0573 9.03061 19.0691 9.01543 19.0771 8.99805L19.8535 7.31641C19.86 7.30247 19.8677 7.28993 19.877 7.2793L19.8799 7.27637C19.886 7.26948 19.8933 7.26417 19.9004 7.25879Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default ChatVideoSelectedIcon
